/* PavCon, LLC Proprietary.All rights reserved 2022 */

const INITIAL_STATE: ConveyorAdminState = {
  file: [],
  hasAccess: false,
  configuration: null
};

export const NAMESPACE = 'CONVEYOR-ADMIN';

export const ConveyorAdminActions = {
  INIT: `${NAMESPACE}.INIT`,
  UPDATE: `${NAMESPACE}.UPDATE`,
  SET_ACCESS: `${NAMESPACE}.SET_ACCESS`,
  SET_CONFIGURATION: `${NAMESPACE}.SET_CONFIGURATION`,
  KEEP_CURRENT_STATE: `${NAMESPACE}.KEEP_CURRENT_STATE`,
  SET_LAST_STATE: `${NAMESPACE}.SET_LAST_STATE`,
  KEEP_LAST_STATE: `${NAMESPACE}.KEEP_LAST_STATE`,
  CLEAR_LAST_STATE: `${NAMESPACE}.CLEAR_LAST_STATE`,
};

export const ConveyorAdminReducer = (state: ConveyorAdminState = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case ConveyorAdminActions.INIT:
        return state;
      case ConveyorAdminActions.SET_ACCESS:
        return {
          ...state,
          hasAccess: action.payload
        };
        case ConveyorAdminActions.SET_CONFIGURATION:
        return {
          ...state,
          configuration: action.payload
        };
    default:
      return state;
  }
};

export interface ConveyorAdminState {
  file: FileColumnConfig[];
  hasAccess: boolean;
  configuration: any;
}


export interface FileColumnConfig {
    colName: string;
    order: number;
    include: boolean;
    dataType: string;
    data: any;
    displayName: string;
    editable: boolean;
    lookup: boolean;
    sortable: boolean;
    orderType?: string;
    recordId: boolean;
    primaryKey: boolean;
    importRules: FileColumnImportRuleConfig;
    reviewFieldSize: string;
    mapField: string;
}
export interface FileColumnImportRuleConfig {
  rules: any[];
  beforeTransforms: FileConfigImportTransformConfig[];
  afterTransforms: FileConfigImportTransformConfig[];
}
export interface FileConfigImportTransformConfig {
  action: string;
  arg1: any;
  arg2: any;
}
/* PavCon, LLC Proprietary.All rights reserved 2022 */
